import { render, staticRenderFns } from "./ModalForgotPinByEmail.vue?vue&type=template&id=494abace&"
import script from "./ModalForgotPinByEmail.vue?vue&type=script&lang=js&"
export * from "./ModalForgotPinByEmail.vue?vue&type=script&lang=js&"
import style0 from "./ModalForgotPinByEmail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports